import React from 'react'
import {get} from "../../../../Model/Network/Config/Axios";
import {FloatInput, FloatSelect} from "../FloatLabelInput";
import {showToast} from "../../fToast/ToastCallback";
import FindMaster from './Master';
import { FloatFile } from '../FloatLabelInput/FloatFile';
import {MultiselectDropDown} from './MultiSelect';
import MultiMaster from './MultiMaster';
import _ from 'lodash';
import SearchEndPoint from './SearchEndPoint'
import moment from 'moment';
import { Oval } from 'react-loader-spinner';
import Attachments from '../../Components/Attachments';

class Form extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			forms: [],
			master: this.props.masterKeyValue?{...this.props.masterKeyValue}: {},
			dependentKeyValue: this.props.dependentKeyValue ? this.props.dependentKeyValue:{},
			FilterData: this.props.filterData ? this.props.filterData : {},
			loading:false,
			prefillForm:{}
		}
	}
	
    autoFillKeyObjectValue = {}

	handleChange=(value,item)=> {
		this.setState((prev)=>{
			return {
				...prev,
				dependentKeyValue:{
					...prev.dependentKeyValue,
					[item.fieldId]:value
				}
			}
		})
		if(this.props.onChange) {
			this.props.onChange(item,value);
		}
	}

	updateFields=()=>{
		Object.keys(this.props.preFill).forEach(key=>{
			for(let i=0;i<this.state.forms.length;i++){
				if(this.state.forms[i].id===Number(key)){
					if(this.state.forms[i].type==="SELECT" && this.checkDependableForm(this.state.forms[i])){
						this.handleChange(this.props.preFill[key],this.state.forms[i])
					}
					else if(this.state.forms[i].type==="FILE" && this.checkDependableForm(this.state.forms[i])){
						this[`field:${this.state.forms[i].id}`].setValue(this.props.preFill[key])
					}
					break;
				}
			}
		})
	}
	

	componentDidUpdate(prev,prevState) {
		if(!_.isEqual(this.props.dependentKeyValue,prev.dependentKeyValue)) {
			this.setState((prev)=>{
				return({
					...prev,
					dependentKeyValue:this.props.dependentKeyValue
				})
			})
		}
		if(!_.isEqual(this.props.masterKeyValue,prev.masterKeyValue)) {
			this.setState((prev)=>{
				return({
					...prev,
					master:this.props.masterKeyValue
				})
			})
		}
		if(!_.isEqual(this.props.filterData,prev.filterData)) {
			this.setState(prev=>{
				return({
					...prev,
					FilterData:this.props.filterData
				})
			})
		}
		if(this.props.initialValues && !_.isEqual(this.props.initialValues, prev.initialValues)) {
			this.setValues(this.props.initialValues);
		}
		if(this.props && this.props.preFill && prev.preFill && this.props.preFill!==prev.preFill) {
			this.updateFields();
			this.setState((prev)=>{
				return {
					...prev,
					prefillForm:this.props.preFill
				}
			})
		}
		if(this.state && this.state.forms && prevState.forms && this.state.forms!==prevState.forms) {
			if(this.props && this.props.preFill && Object.keys(this.props.preFill).length>0){
				this.updateFields()
			}
		}
	}

	componentDidMount() {
		if (this.props.handler) {
			this.props.handler(this)
		}	    
		
	}

	
	// checkDependableCondition = (value) => {
    //     if(this.state.dependentKeyValue[value.first]===value.second) {
    //         return true
    //     }
    //     return false
    // }

	checkDependableCondition = (value) => {
		if(value && value.first && value.second) {
			let dependencyKeys=value.first.split("||");
			let dependencyValues=value.second.split("||");
			for(let i=0;i<dependencyKeys.length;i++) {
				let key=dependencyKeys[i].trim();
				let value=dependencyValues[i].trim();
				if(this.state.dependentKeyValue[key]!==value) {
					return false
				}
			}
			return true
		}
		return false;
    }
    

    checkDependableForm = (item) => {
        if(item.dependentField && Object.keys(item.dependentField).length>0) {
              return this.checkDependableCondition(item.dependentField)
        }
        return true
    }

	checkDecimalPrecision = (value,id)=>{
		if(value && value.indexOf(".")!==-1 && ((value.length)-value.indexOf(".")>4)){
			showToast({
				"type":"error",
				"message":"Maximum 3 decimal digits allowed"
			})
			this[`field:${id}`].value=value.slice(0,value.indexOf(".")+4);
			return;
		}
	}


	setInitialFieldValues = (initialValues) => {
		const form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
		  const field = form[i];
		  const type = field.type;
		  let initialValue = initialValues[field.fieldId];
		  if(!initialValue) {
			initialValue =   initialValues[field.name]
		}
		  if (initialValue !== undefined) {
			if ((type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER') && this[`field:${field.id}`]) {
			  this[`field:${field.id}`].value = initialValue;
			}else if(type === 'DATE' && this[`field:${field.id}`]){
		    	this[`field:${field.id}`].value = moment(initialValue,["DD-MM-YYYY",'YYYY-DD-MM','YYYY-MM-DD']).format("YYYY-MM-DD");;
			} else {
			  const fieldRef = this[`field:${field.id}`];
			  if (fieldRef && typeof fieldRef.setValue === 'function') {
				fieldRef.setValue(initialValue);
			  }
			}
		  }
		}
	  };

	clear = () => {
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			this[`field:${field.id}`].value = ""
		}
	}

	getLength = () => {
		return this.state.forms.length;
	}

	getKeyValue = (cb) => {
		if(this.state.loading){
			showToast({
				type:'error',
				message:'Custom forms are loading, please wait...'
			})
			return;
		}
		let data = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined
			//specifically for Jupiter CN
			if(this.props && this.props.creditNote && this.props.tenant && this.props.field_Id_To_Hide && field.fieldId && this.props.field_Id_To_Hide===field.fieldId && this.props.tenant==="JPT"){
					data[`${field.id}`] = "";
					continue;
			}
			if(this.checkDependableForm(field)) {
				if(type === 'TEXT' || type==='EMAIL'||type==='NUMBER'||type==='DATE') {
					if(field.masterType) value = this[`field:${field.id}`].getValue();
					else value = this[`field:${field.id}`].value;
			   } else {
					value = this[`field:${field.id}`] && this[`field:${field.id}`].getValue();
			   }
			 } else {
			 }
			 
			if(value){
				data[field.id] = value
			} else if(field.required && field.dependentField && Object.keys(field.dependentField).length>0 ) {
                if(this.checkDependableForm(field) && !value) {
                    showToast({
                        type:'error',
                        message: `${field.name} is marked required`
                    })
                    return
                } else {
                    data[`${field.id}`] = "";
                }
           } else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if(!field.required && !value) {
                data[`${field.id}`] = "";
            }
		}
		cb(data)
	}

	getFilledKeyValue = (cb) => {
		if(this.state.loading){
			showToast({
				type:'error',
				message:'Custom forms are loading, please wait...'
			})
			return;
		}
		let data = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined

			// Skip Jupiter CN specific fields
			if(this.props && this.props.creditNote && this.props.tenant && this.props.field_Id_To_Hide && field.fieldId && this.props.field_Id_To_Hide===field.fieldId && this.props.tenant==="JPT"){
				continue;
			}

			if(this.checkDependableForm(field)) {
				if(type === 'TEXT' || type==='EMAIL'||type==='NUMBER'||type==='DATE') {
					if(field.masterType) value = this[`field:${field.id}`].getValue();
					else value = this[`field:${field.id}`].value;
				} else {
					value = this[`field:${field.id}`].getValue();
				}
			}

			// Only add to data if there is a value
			if(value) {
				data[field.id] = value;
			}
		}
		cb(data)
	}

	getFieldValePair = (cb) => {
		let data = {}
		let formData = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined
			if(this.checkDependableForm(field)) {
				if(type === 'TEXT' || type==='EMAIL'||type==='NUMBER'||type==='DATE') {
					value = this[`field:${field.id}`].value;
			   } else {
					value = this[`field:${field.id}`].getValue();
			   }
			 } else {
			 }
			if(value){
				data[field.fieldId] = value
				formData[field.id] = value
			} else if(field.required && Object.keys(field.dependentField).length>0 ) {
                if(this.checkDependableForm(field) && !value) {
                    showToast({
                        type:'error',
                        message: `${field.name} is marked required`
                    })
                    return
                } else {
                    data[`${field.fieldId}`] = "";
					formData[field.id] = "";
                }
           } else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if(!field.required && !value) {
                data[`${field.fieldId}`] = "";
				formData[field.id] = "";
            }
		}
		
		cb(data,formData)
	}

	getCustomFormKeyValue = (cb) => {
		let data = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined
			if(this.checkDependableForm(field)) {
				if(type === 'TEXT' || type==='EMAIL'||type==='NUMBER'||type==='DATE') {
					 value = this[`field:${field.id}`].value;
				} else {
				 	value = this[`field:${field.id}`].getValue();
				}
			}

			if(value) {
				data[field.id] = {"value":value,"name":field.name,"key":field.fieldId}
			} else if(field.required && Object.keys(field.dependentField).length>0 ) {
				if(this.checkDependableForm(field) && !value) {
                    showToast({
                        type:'error',
                        message: `${field.name} is marked required`
                    })
                    return
                } else {
                    data[`${field.id}`] = {"value":"","name":field.name,"key":field.fieldId}
                }
			}else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if(!field.required && !value) {
				data[field.id] = {"value":"","name":field.name,"key":field.fieldId}
            }
		}
		cb(data)
	}

	getForm = (cb) => {
		let data = []
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let value = undefined;
			let type = field.type;

			if(this.checkDependableForm(field)) {
				if(type === 'TEXT' || type==='EMAIL'||type==='NUMBER'||type==='DATE') {
					value = this[`field:${field.id}`].value;
		  		 } else {
					value = this[`field:${field.id}`].getValue();
		  	 } 
			} 
			
			if(value) {
				data.push({"value":value,"name":field.name,"key":field.name,id:field.id})
			}
			else if(field.required && Object.keys(field.dependentField).length>0 ) {
				if(this.checkDependableForm(field) && !value) {
                    showToast({
                        type:'error',
                        message: `${field.name} is marked required`
                    })
                    return
                } else {
					data.push({"value":"","name":field.name,"key":field.name,id:field.id})

                }
			}else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if(!field.required && !value) {
				data.push({"value":"","name":field.name,"key":field.name,id:field.id})
            }
			
			
		}
		cb(data)
	}

	// New method to set values from parent
	setValues = (values) => {
		if (!values || !this.state.forms.length) return;
		 const form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			const field = form[i];
			const type = field.type;
			let value = values[field.fieldId];
			
			if(value === undefined) {
				value = values[field.name];
			}

			if (value !== undefined) {
				
				if (type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER') {
					if (this[`field:${field.id}`]) {
						this[`field:${field.id}`].value = value;
					}
				} else if(type === 'DATE'){
					if (this[`field:${field.id}`]) {
						this[`field:${field.id}`].value = value ? moment(value, ["DD-MM-YYYY", "YYYY-MM-DD", "YYYY-DD-MM"]).format("YYYY-MM-DD") : "";
					}
				} else  {
					const fieldRef = this[`field:${field.id}`];
					if (fieldRef && typeof fieldRef.setValue === 'function' && fieldRef.ref) {
						fieldRef.setValue(value);
					}
				}
			}
		}
	}


   isLoading = () => this.state.loading;

   updateForms = (forms=[]) => {
	 this.setState({
		...this.state,
		forms:forms,
		loading:false
	 })
   }

	loadForm = (key) => {
		this.setState({ loading: true });
		get(`/forms/${key}`, (e, r) => {
			if (r) {
				this.setState({
					...r,
					loading:false
				},() =>{
					if(this.props.initialValues &&  Object.keys(this.props.initialValues).length > 0) 
					this.setInitialFieldValues(this.props.initialValues)
				})
			} else {
				this.setState({ loading: false });
			}
		})
	}

	mapItem = (item,index) => {
		let type  = item.type.toLowerCase();
		//specifically for Jupiter CN
		if(this.props && this.props.creditNote && this.props.field_Id_To_Hide && this.props.tenant && item.fieldId && this.props.field_Id_To_Hide===item.fieldId && this.props.tenant==="JPT"){
				return;
		}
		if ((type === 'email' || type === 'number' || type === 'text' || type === 'date') && this.checkDependableForm(item)) {
			if(item.type==='TEXT' && item.masterType) {
				return (
					<SearchEndPoint
						// disabled={editable && !editableTypes.includes(item.name)}
						allowSpecialCharacters={item.fieldId === 'invoice no' || item.fieldId === 'description' ? true : true}
						defaultValue={this.props.preFill ?  (this.props.preFill[item.fieldId]? this.props.preFill[item.fieldId] : this.props.preFill[item.id]) : null} 
						key={item.id} 
						className='mt2' 
						label={item.name} 
						type={item.type.toLowerCase()}
						placeholder={item.placeholder} 
						masterType={item.masterType}
						filterData={this.state.FilterData}
						ref={ref=>this[`field:${item.id}`] = ref}
						 />

				)
			}
			
			return (
				<FloatInput
				defaultValue={this.props.preFill ?  (this.props.preFill[item.fieldId]?this.props.preFill[item.fieldId]:this.props.preFill[item.id]) : null}
				 onChange={(val)=>{
					if(type==="number"){
						this.checkDecimalPrecision((val&&val.target&&val.target.value)?val.target.value:"",item.id)
					}
					if(this.props.onChange) {
						this.props.onChange(item,(val&&val.target&&val.target.value)?val.target.value:"");
					}
				 }}
				 diasblePrev={(item.type.toLowerCase()=== "date" && item.min===1)?true:undefined}
				 maxLength={item.max} 
				 min={item.prevDate?(moment(item.prevDate).format('YYYY-MM-DD')) : item.min} 
				 max={item.nextDate?(moment(item.nextDate).format('YYYY-MM-DD')) :''} 
				 key={item.id}
				 title={item.name?item.name:item.placeholder} 
				 placeholder={item.placeholder} 
				 type={item.type.toLowerCase()}
				 handleRef={({ref}) => {
						this[`field:${item.id}`] = ref;
		}}/>)
		} else if (type === "select" && this.checkDependableForm(item)) {
			return (
				<div className="full-width">
							<FloatSelect
								defaultValue={this.props.preFill ?  (this.props.preFill[item.fieldId]?this.props.preFill[item.fieldId]:this.props.preFill[item.id]) : null}
								firstValue={true}
								key={index}
								title={item.name}
								onChange={(value ) =>{
									this.setState({
										...this.state,
										// isPrefill:false,
										dependentKeyValue:{
											...this.state.dependentKeyValue,
											[item.fieldId]:value
										}
									})
									if(this.props.onChange) {
										this.props.onChange(item,value);
									}
								}}
								items={item.values}
								handleRef={(ref) => this[`field:${item.id}`] = ref}
							/>
							
					</div>
			)
		}  else if (type === "multiselect" && this.checkDependableForm(item)) {
			return (
				<MultiselectDropDown
						key={index}
						title={item.name}
						options={item.values.map(j=>({value:j.value,label:j.key}))}
						handleRef={ref => this[`field:${item.id}`] = ref}
					/>
			)
		} else if(type === 'file' && this.checkDependableForm(item)) {
			return (
				<div key={item.id} style={{ marginBottom: 18, position: 'relative' }}>
				<FloatFile 
						key={index}
						title={item.name}
						required={item.required}
						placeholder={`Select File`}
						handleRef={ref => this[`field:${item.id}`] = ref}
						defaultValue={this.props.preFill ?  (this.props.preFill[item.fieldId]?this.props.preFill[item.fieldId]:this.props.preFill[item.id]) : null}
						onUpload={(val) => {
							this.setState((prev)=>{
								return {
									...prev,
									prefillForm:{
										...prev.prefillForm,
										[item.id]:val
									}
								}
							})
							if(this.props.onChange) this.props.onChange(val,item)
						}}
						/>
						{(this.state.prefillForm && this.state.prefillForm[item.id])?<Attachments
							hideNumber={true}
							editable={false}
							attachments={[this.state.prefillForm[item.id]]}
						/>:null}
					{/*loader in case ocr is running on the file */}
					{this.props.customFormOcr && this.props.customFormOcr[item.fieldId] && <div style={{position:'absolute',top:0,right:0}}><Oval type="Oval" height={14} width={14} /></div>}
				</div>)
		} else if(item.type==='MULTIMASTER' && this.checkDependableForm(item)) {
			return (
			   <MultiMaster 
				   key={item.id}
				   master={this.state.master}
				   handleRef={ref => this[`field:${item.id}`] = ref}
				   details={item}
				   fieldId={item.fieldId?item.fieldId:item.name}
				   label={`${item.name} ${item.required?'*':''}`}
				   placeholder={item.placeholder}
				   onUpdate={()=>{

				   }}
			   />
			)
	   }else if (type === 'master' && this.checkDependableForm(item)) {
		const extra = (item.fieldId === 'costcenter_inv') && this.props.extra ? this.props.extra : {};

            return (
				<FindMaster
				key={index}
				defaultValue={this.props.preFill ?  (this.props.preFill[item.fieldId]?this.props.preFill[item.fieldId]:this.props.preFill[item.id]) : null}
				title={item.name}
				required={item.required}
				placeholder={`Search the ${item.placeholder}`}
				handleRef={ref => this[`field:${item.id}`] = ref}
				fieldId={item.fieldId?item.fieldId:item.name}
				details={item}
				onUpdate={(i,next) => {
					let master = {...this.state.master};
					let key = next
					master[key] = i[key];
					this.setState({
						...this.state,
						master,
						dependentKeyValue:{
							...this.state.dependentKeyValue,
							[item.fieldId]:i[key]
						}
					})
					Object.keys(i).forEach(insideItem=>{
						let mItem = this.autoFillKeyObjectValue && this.autoFillKeyObjectValue[insideItem];
						if(mItem) {	
							if(mItem.type==='TEXT' && this[`field:${mItem.id}`]) {
								this[`field:${mItem.id}`].value = (i[insideItem] || "");
							}
						}
					})
				   
				}}
				master={this.state.master}
				extra={extra}
			/>
            )
        }


	}

	render() {

		for (let item in this.state.forms) {
			let mItem = this.state.forms[item];
			if (mItem.autofill || mItem.autoFill) {
				this.autoFillKeyObjectValue[mItem.fieldId] = mItem;
			}
		}
		
		return (
			<div style={{
				marginTop:20,
				marginBottom:10
			}}>
				{this.state.forms.length>0?
				<p style={{margin:'10px 0px',fontSize:16,fontWeight:600}}>
					{this.props.title && this.props.service? 
					`${this.props.title}-${this.props.service} Line Item Field`
					 : this.props.service ? `${this.props.service} Line Item Field` : this.props.label ? this.props.label : 'Additional Details'}</p>:null }
				<p style={{margin:'10px 0px',fontSize:14,fontWeight:300}}>
					{this.state.forms.length > 0 && this.props.desc  ? this.props.desc : null}
				</p>
				{
					this.state.forms.map(this.mapItem)
				}
			</div>
		)
	}

}

export {
	Form
}
